/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/3/2023
 */
import BaseObject from "@shared/BaseObject.js";
import {plainToClass} from "@qwoach/class-transformer-wrapper";

export default class RefCounter extends BaseObject {

	object: null
	count: number = 0

	constructor() {
		super();
	}

	addObject(object){
		if(!this.object){
			this.object = object
		}
		this.count++
	}

	removeObject(){
		this.count--
		if(this.count <= 0){
			this.object = null
		}
	}

	isEmpty(){
		return this.object == null
	}
}

export let refCounterMapTransform = (refCounterMap) => {
	refCounterMap = refCounterMap.value || refCounterMap
	Object.keys(refCounterMap).forEach(key => {
		refCounterMap[key] = plainToClass(RefCounter, refCounterMap[key])
	})
	return refCounterMap;
}

